/// <amd-module name="SuiteCommerce.ShippingBar.Main.Model"/>
define("SuiteCommerce.ShippingBar.Main.Model", ["require", "exports", "Backbone", "underscore", "SuiteCommerce.ShippingBar.Configuration.Helper", "SuiteCommerce.ShippingBar.Common.Utils", "SuiteCommerce.ShippingBar.Common.Cookies"], function (require, exports, Backbone_1, _, Configuration_Helper_1, Utils_1, Cookies_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ShippingBarModel = Backbone_1.Model.extend({
        initialize: function (attributes) {
            var _this = this;
            var cart = attributes.cart;
            var pdp = attributes.pdp;
            this.updateCurrencyConfiguration();
            this.set('cartAmount', 0);
            this.set('headerMessageIndex', 0);
            this.set('isOpen', true);
            this.updateCartAmount();
            cart.on('afterAddLine', function () {
                _this.updateCartAmount(true);
            });
            cart.on('afterRemoveLine', function () {
                _this.updateCartAmount(true);
            });
            cart.on('afterUpdateLine', function () {
                _this.updateCartAmount(true);
            });
            pdp.on('afterOptionSelection', function () {
                _this.updateCartAmount();
            });
            pdp.on('afterQuantityChange', function () {
                _this.updateCartAmount();
            });
        },
        updateCurrencyConfiguration: function () {
            var _a = Configuration_Helper_1.ConfigurationHelper.getCurrencyConfig(), goalCurrencyCode = _a[0], shippingAmount = _a[1], haveSameCode = _a[2];
            this.set('goalCurrencyCode', goalCurrencyCode);
            this.set('haveSameCode', haveSameCode);
            this.set('shippingAmount', shippingAmount);
        },
        updateCartAmount: function (triggerFromCart) {
            var _this = this;
            var cartLinesPromise = this.attributes.cart.getLines();
            var cartAmountBeforeUpdate = this.get('cartAmount');
            cartLinesPromise.done(function (value, result) {
                var amount = _.reduce(value, function (memoizer, value) {
                    return memoizer + value.amount;
                }, 0);
                _this.set('cartAmount', amount);
                if (!!triggerFromCart) {
                    _this.trigger('cartAmount:changed');
                }
                else {
                    _this.trigger('pdpAmount:changed');
                }
            });
            this.isStatusChange(cartAmountBeforeUpdate, this.get('cartAmount'));
        },
        updateHeader: function () {
            this.trigger('pdpPage:isLoaded');
        },
        isStatusChange: function (amountBefore, amountAfter) {
            // tslint:disable-next-line:max-line-length
            if (amountBefore < amountAfter && amountAfter >= this.attributes.shippingAmount && amountBefore < this.attributes.shippingAmount) {
                var cookies = Cookies_1.default.getInstance();
                cookies.set('isOpen', true);
                this.trigger('cartAmount:changed');
            }
        },
        parseCurrecy: function (amountToParse) {
            if (!!this.get('haveSameCode')) {
                return Utils_1.Utils.formatCurrency(amountToParse.toFixed());
            }
            var parsedAmount = jQuery.trim(Utils_1.Utils.formatCurrency(amountToParse.toFixed(), ' '));
            return this.get('goalCurrencyCode') + " " + parsedAmount;
        },
        getMessage: function (messageName, amountWithItem) {
            this.updateCurrencyConfiguration();
            var progressMessage = this.get(messageName);
            var goalValue = this.parseCurrecy(this.get('shippingAmount') - amountWithItem);
            goalValue = goalValue.replace('.00', '').replace(' ', '').replace('$', '$$$');
            goalValue = "<span class=\"sc-shippingbar-common-value-text-color\">" + goalValue + "</span>";
            return progressMessage.replace(/({{(value|to-value)}}|\[\[(value|to-value)\]\])/g, goalValue);
        },
    });
});
